/* eslint prettier/prettier: "off" */
/* eslint no-use-before-define: "off" */
/* eslint quotes: "off" */
/* eslint unicorn/prefer-code-point: "off" */

/**
 *
 * This file was originally copied from a fully tested workflow in the banking-web repo.
 * It was modified to support additional card management features.
 * As of today (10/17/2024), banking-web is missing some features (e.g. toggling card details).
 *
 * https://github.com/squareup/banking-web/blob/main/src/workflow/card-settings-v2/index.ts
 */

import workflow from "@banking/ui/lib/workflow";
import { Card, CardStatus, LockCardRequest, Relationship, RetrieveCardRequest, UnlockCardRequest } from "@square/dashboard-protos/models/squareup/bbdebit/cardmanagement";
import { CardCustomization, GetCardCustomizationRequest } from "@square/dashboard-protos/models/squareup/bizbank/service";
import { GetCheckingDirectDepositAccountRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/common/checking_direct_deposit_account/checking_direct_deposit_account';

// State
// =============================================================================
export let CardSettingError = /*#__PURE__*/function (CardSettingError) {
  CardSettingError[CardSettingError["None"] = 0] = "None";
  CardSettingError[CardSettingError["Generic"] = 1] = "Generic";
  return CardSettingError;
}({});
export let Setting = /*#__PURE__*/function (Setting) {
  Setting["None"] = "SETTING_NONE";
  Setting["ActivateCard"] = "SETTING_ACTIVATE_CARD";
  Setting["AtmLimits"] = "SETTING_ATM_LIMITS";
  Setting["BillingAddress"] = "SETTING_BILLING_ADDRESS";
  Setting["CancelCard"] = "SETTING_CANCEL_CARD";
  Setting["NotificationsPreferences"] = "SETTING_NOTIFICATIONS_PREFERENCES";
  Setting["ResetPin"] = "SETTING_RESET_PIN";
  return Setting;
}({});
export let DepositAccountDataState = /*#__PURE__*/function (DepositAccountDataState) {
  DepositAccountDataState[DepositAccountDataState["NOT_REQUESTED"] = 0] = "NOT_REQUESTED";
  DepositAccountDataState[DepositAccountDataState["FETCHING"] = 1] = "FETCHING";
  DepositAccountDataState[DepositAccountDataState["HAS_DEPOSIT_ACCOUNT"] = 2] = "HAS_DEPOSIT_ACCOUNT";
  DepositAccountDataState[DepositAccountDataState["NO_DEPOSIT_ACCOUNT"] = 3] = "NO_DEPOSIT_ACCOUNT";
  DepositAccountDataState[DepositAccountDataState["ERROR"] = 4] = "ERROR";
  return DepositAccountDataState;
}({});
const INITIAL_CARD_STATE = {
  activeSetting: Setting.None,
  card: null,
  cardCustomization: null,
  error: CardSettingError.None,
  loading: true,
  showCardDetails: false,
  toggleLoading: {
    lockCard: false,
    showCardDetails: false
  },
  unitToken: null
};
export const INITIAL_STATE = {
  // State that can refresh after a card action
  ...INITIAL_CARD_STATE,
  // State that doesn’t need to refresh after a card action
  depositAccountData: DepositAccountDataState.NOT_REQUESTED
};
export const createState = (overrides = {}) => ({
  ...INITIAL_STATE,
  ...overrides
});
export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["Initialize"] = "CARD_SETTINGS/INITIALIZE";
  ActionType["GetCardCustomizationReceived"] = "CARD_SETTINGS/GET_CARD_CUSTOMIZATION_RECEIVED";
  ActionType["GetCardCustomizationRejected"] = "CARD_SETTINGS/GET_CARD_CUSTOMIZATION_REJECTED";
  ActionType["GetCheckingDirectDepositAccount"] = "CARD_SETTINGS/GET_CHECKING_DIRECT_DEPOSIT_ACCOUNT";
  ActionType["GetCheckingDirectDepositAccountReceived"] = "CARD_SETTINGS/GET_CHECKING_DIRECT_DEPOSIT_ACCOUNT_RECEIVED";
  ActionType["GetCheckingDirectDepositAccountRejected"] = "CARD_SETTINGS/GET_CHECKING_DIRECT_DEPOSIT_ACCOUNT_REJECTED";
  ActionType["LockCardReceived"] = "CARD_SETTINGS/LOCK_CARD_RECEIVED";
  ActionType["LockCardRejected"] = "CARD_SETTINGS/LOCK_CARD_REJECTED";
  ActionType["RetrieveCardReceived"] = "CARD_SETTINGS/RETRIEVE_CARD_RECEIVED";
  ActionType["RetrieveCardRejected"] = "CARD_SETTINGS/RETRIEVE_CARD_REJECTED";
  ActionType["SetActiveSetting"] = "CARD_SETTINGS/SET_ACTIVE_SETTING";
  ActionType["UnlockCardReceived"] = "CARD_SETTINGS/UNLOCK_CARD_RECEIVED";
  ActionType["UnlockCardRejected"] = "CARD_SETTINGS/UNLOCK_CARD_REJECTED";
  ActionType["UserClickActivateCard"] = "CARD_SETTINGS/USER_CLICK_ACTIVATE_CARD";
  ActionType["UserClickAtmLimits"] = "CARD_SETTINGS/USER_CLICK_ATM_LIMITS";
  ActionType["UserClickBillingAddress"] = "CARD_SETTINGS/USER_CLICK_BILLING_ADDRESS";
  ActionType["UserClickCancelCard"] = "CARD_SETTINGS/USER_CLICK_CANCEL_CARD";
  ActionType["UserClickOrderCard"] = "CARD_SETTINGS/USER_CLICK_ORDER_CARD";
  ActionType["UserClickResetPin"] = "CARD_SETTINGS/USER_CLICK_RESET_PIN";
  ActionType["UserClickNotificationsPreferences"] = "CARD_SETTINGS/USER_CLICK_NOTIFICATIONS_PREFERENCES";
  ActionType["UserToggleCardDetails"] = "CARD_SETTINGS/USER_TOGGLE_CARD_DETAILS";
  ActionType["UserToggleLockCard"] = "CARD_SETTINGS/USER_TOGGLE_LOCK_CARD";
  ActionType["UserClickViewReplacementCard"] = "CARD_SETTINGS/USER_CLICK_VIEW_REPLACEMENT_CARD";
  return ActionType;
}({});
export const initializeAction = (cardToken, unitToken) => ({
  type: ActionType.Initialize,
  cardToken,
  unitToken
});
export const retrieveCardReceivedAction = (response, toggleCardDetails = false) => ({
  type: ActionType.RetrieveCardReceived,
  response,
  toggleCardDetails
});
export const getCardCustomizationReceivedAction = response => ({
  type: ActionType.GetCardCustomizationReceived,
  response
});
export const getCardCustomizationRejectedAction = error => ({
  type: ActionType.GetCardCustomizationRejected,
  error
});
export const getCheckingDirectDepositAccountAction = unitToken => ({
  type: ActionType.GetCheckingDirectDepositAccount,
  unitToken
});
export const getCheckingDirectDepositAccountReceivedAction = response => ({
  type: ActionType.GetCheckingDirectDepositAccountReceived,
  response
});
export const getCheckingDirectDepositAccountRejectedAction = error => ({
  type: ActionType.GetCheckingDirectDepositAccountRejected,
  error
});
export const lockCardReceivedAction = response => ({
  type: ActionType.LockCardReceived,
  response
});
export const lockCardRejectedAction = error => ({
  type: ActionType.LockCardRejected,
  error
});
export const retrieveCardRejectedAction = error => ({
  type: ActionType.RetrieveCardRejected,
  error
});
export const setActiveSettingAction = setting => ({
  type: ActionType.SetActiveSetting,
  setting
});
export const unlockCardReceivedAction = response => ({
  type: ActionType.UnlockCardReceived,
  response
});
export const unlockCardRejectedAction = error => ({
  type: ActionType.UnlockCardRejected,
  error
});
export const userClickActivateCardAction = () => ({
  type: ActionType.UserClickActivateCard
});
export const userClickAtmLimitsAction = () => ({
  type: ActionType.UserClickAtmLimits
});
export const userClickBillingAddressAction = () => ({
  type: ActionType.UserClickBillingAddress
});
export const userClickCancelCardAction = () => ({
  type: ActionType.UserClickCancelCard
});
export const userClickOrderCardAction = () => ({
  type: ActionType.UserClickOrderCard
});
export const userClickNotificationsPreferencesAction = () => ({
  type: ActionType.UserClickNotificationsPreferences
});
export const userClickResetPinAction = () => ({
  type: ActionType.UserClickResetPin
});
export const userClickViewReplacementCardAction = () => ({
  type: ActionType.UserClickViewReplacementCard
});
export const userToggleCardDetailsAction = value => ({
  type: ActionType.UserToggleCardDetails,
  value
});
export const userToggleLockCardAction = value => ({
  type: ActionType.UserToggleLockCard,
  value
});
const DEFAULT_RETRIEVE_CARD_RESPONSE_FIELDS = ['id', 'status', 'card_brand', 'card_type', 'fulfillment', 'last_four', 'relationship', 'balance_id', 'can_digital_spend', 'is_eligible_for_physical_card_pair', 'expiration_data.replacement_card', 'expiration_data.status', 'previous_card_id'];
function handleInitialize(state, context, action) {
  const {
    cardToken,
    unitToken
  } = action;
  const work = () => context.cardManagementService.retrieveCard(RetrieveCardRequest.create({
    cardToken,
    fieldMask: {
      paths: [...DEFAULT_RETRIEVE_CARD_RESPONSE_FIELDS]
    }
  })).then(retrieveCardReceivedAction, retrieveCardRejectedAction);
  return [{
    ...state,
    ...INITIAL_CARD_STATE,
    unitToken
  }, work];
}
function handleGetCardCustomizationReceived(state, action) {
  const cardCustomization = action.response.cardCustomization ?? CardCustomization.create();
  return [{
    ...state,
    cardCustomization,
    loading: false
  }, null];
}
function handleGetCardCustomizationRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Card settings: Fetching card customization failed ${error}`);
  return [{
    ...state,
    error: CardSettingError.Generic,
    loading: false
  }, null];
}
function handleGetCheckingDirectDepositAccount(context, state, action) {
  const {
    unitToken
  } = action;
  const work = () => context.getCheckingDirectDepositAccount(GetCheckingDirectDepositAccountRequest.create({
    unitToken,
    fieldMask: {
      paths: ['data.account_number_suffix']
    }
  })).then(getCheckingDirectDepositAccountReceivedAction, getCheckingDirectDepositAccountRejectedAction);
  return [{
    ...state,
    depositAccountData: DepositAccountDataState.FETCHING
  }, work];
}
function handleGetCheckingDirectDepositAccountReceived(context, state, action) {
  const {
    response
  } = action;
  if (response.error) {
    context.sentry.captureException(`Card settings: GetCheckingDirectDepositAccount failed ${response.error}`);
    return [{
      ...state,
      depositAccountData: DepositAccountDataState.ERROR
    }, null];
  }
  return [{
    ...state,
    depositAccountData: response.data?.accountNumberSuffix ? DepositAccountDataState.HAS_DEPOSIT_ACCOUNT : DepositAccountDataState.NO_DEPOSIT_ACCOUNT
  }, null];
}
function handleGetCheckingDirectDepositAccountRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Card settings: GetCheckingDirectDepositAccount failed ${error}`);
  return [{
    ...state,
    depositAccountData: DepositAccountDataState.ERROR
  }, null];
}
function handleLockCardReceived(context, state, action) {
  const {
    card,
    errors
  } = action.response;
  if (errors.length > 0) {
    context.sentry.captureException("Card settings [LockCardReceivedAction]: Failed to lock card");
    return [{
      ...state,
      error: CardSettingError.Generic,
      toggleLoading: {
        ...state.toggleLoading,
        lockCard: false
      }
    }, null];
  }
  if (card == null) {
    context.sentry.captureException("Card settings [LockCardReceivedAction]: Missing updated card from LockCard API response");
    return [{
      ...state,
      error: CardSettingError.Generic,
      toggleLoading: {
        ...state.toggleLoading,
        lockCard: false
      }
    }, null];
  }
  return [{
    ...state,
    // Don’t overwrite the entire card state since RetrieveCard (called during page load) gets more data through field_mask.
    card: Card.create({
      ...state.card,
      status: card.status
    }),
    toggleLoading: {
      ...state.toggleLoading,
      lockCard: false
    }
  }, null];
}
function handleLockCardRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Card settings [LockCardRejectedAction]: Failed to lock card ${error}`);
  return [{
    ...state,
    error: CardSettingError.Generic,
    toggleLoading: {
      ...state.toggleLoading,
      lockCard: false
    }
  }, null];
}
function handleRetrieveCardReceived(context, state, action) {
  const {
    card
  } = action.response;
  if (card == null) {
    context.sentry.captureException("Card settings: Missing card");
    return [{
      ...state,
      error: CardSettingError.Generic,
      loading: false
    }, null];
  }
  const cardCustomizations = card.fulfillment?.customization;
  if (cardCustomizations == null || cardCustomizations.length === 0) {
    context.sentry.captureException(`Card settings: Missing card customization id for card - ${card.id}`);
    return [{
      ...state,
      error: CardSettingError.Generic,
      loading: false
    }, null];
  }
  const cardImage = cardCustomizations.length > 0 ? cardCustomizations[0] : null;
  if (cardImage == null) {
    context.sentry.captureException(`Card settings: No card image with type signature found - ${card.id}`);
    return [{
      ...state,
      error: CardSettingError.Generic,
      loading: false
    }, null];
  }

  // No need to fetch card customization when toggling card details on
  if (action.toggleCardDetails) {
    return [{
      ...state,
      card,
      loading: false,
      showCardDetails: true,
      toggleLoading: {
        ...state.toggleLoading,
        showCardDetails: false
      }
    }, null];
  }
  const work = () => context.getCardCustomization(GetCardCustomizationRequest.create({
    customizationToken: cardImage.id
  })).then(getCardCustomizationReceivedAction, getCardCustomizationRejectedAction);
  return [{
    ...state,
    card,
    loading: true
  }, work];
}
function handleRetrieveCardRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Card settings: Fetching card failed ${error}`);
  return [{
    ...state,
    error: CardSettingError.Generic,
    loading: false,
    toggleLoading: {
      ...state.toggleLoading,
      showCardDetails: false
    }
  }, null];
}
function handleSetActiveSetting(context, state, action) {
  const {
    setting
  } = action;
  if (state.card == null) {
    // This is called when closing a modal, and it's expected that the card might not exist
    // if it was just terminated and we're refreshing the card data immediately after closing the settings modal.
    if (setting === Setting.None) {
      return [{
        ...state,
        activeSetting: Setting.None
      }, null];
    }
    context.sentry.captureException("Card settings [SetActionSettingAction]: Missing card");
    return [{
      ...state,
      error: CardSettingError.Generic
    }, null];
  }
  const {
    relationship
  } = state.card;
  if (setting === Setting.CancelCard) {
    return [{
      ...state,
      activeSetting: setting
    }, null];
  }
  if (state.card.status === CardStatus.CARD_STATUS_TERMINATED) {
    // can't access any settings other than account cancelation flow for terminated cards
    return [{
      ...state,
      activeSetting: Setting.None
    }, null];
  }
  switch (setting) {
    case Setting.AtmLimits:
    case Setting.BillingAddress:
    case Setting.NotificationsPreferences:
      {
        if (!relationship.includes(Relationship.RELATIONSHIP_ACCOUNT_HOLDER)) {
          return [{
            ...state,
            activeSetting: Setting.None
          }, null];
        }
        return [{
          ...state,
          activeSetting: setting
        }, null];
      }
    case Setting.None:
    case Setting.ActivateCard:
      {
        if (state.card.status !== CardStatus.CARD_STATUS_ACTIVATABLE) {
          return [{
            ...state,
            activeSetting: Setting.None
          }, null];
        }
        return [{
          ...state,
          activeSetting: setting
        }, null];
      }
    case Setting.ResetPin:
      return [{
        ...state,
        activeSetting: setting
      }, null];
  }
}
function handleUnlockCardReceived(context, state, action) {
  const {
    card,
    errors
  } = action.response;
  if (errors.length > 0) {
    context.sentry.captureException("Card settings [UnlockCardReceivedAction]: Failed to unlock card");
    return [{
      ...state,
      error: CardSettingError.Generic,
      toggleLoading: {
        ...state.toggleLoading,
        lockCard: false
      }
    }, null];
  }
  if (card == null) {
    context.sentry.captureException("Card settings [UnlockCardReceivedAction]: Missing updated card from UnlockCard API response");
    return [{
      ...state,
      error: CardSettingError.Generic,
      toggleLoading: {
        ...state.toggleLoading,
        lockCard: false
      }
    }, null];
  }
  return [{
    ...state,
    // Don’t overwrite the entire card state since RetrieveCard (called during page load) gets more data through field_mask.
    card: Card.create({
      ...state.card,
      status: card.status
    }),
    toggleLoading: {
      ...state.toggleLoading,
      lockCard: false
    }
  }, null];
}
function handleUnlockCardRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`Card settings [UnlockCardRejectedAction]: Failed to unlock card ${error}`);
  return [{
    ...state,
    error: CardSettingError.Generic,
    toggleLoading: {
      ...state.toggleLoading,
      lockCard: false
    }
  }, null];
}
function handleUserClickViewReplacementCard(context, state) {
  const unitToken = state.unitToken;
  if (!unitToken) {
    context.sentry.captureException('Card setting [UserClickViewReplacementCardAction]: Missing unit token');
    return [{
      ...state,
      error: CardSettingError.Generic
    }, null];
  }
  const replacementCardToken = state.card?.expirationData?.replacementCard?.id;
  if (!replacementCardToken) {
    context.sentry.captureException('Card setting [UserClickViewReplacementCardAction]: Missing replacement card token');
    return [{
      ...state,
      error: CardSettingError.Generic
    }, null];
  }
  context.router.transitionTo('banking.card-settings', unitToken, replacementCardToken);
  return [state, null];
}
function handleUserToggleCardDetails(context, state, action) {
  const {
    value: showCardDetails
  } = action;
  const hasFullCardDetails = Boolean(state.card?.fullPan);
  const cardToken = state.card?.id;
  if (cardToken == null) {
    context.sentry.captureException('Card setting [UserToggleCardDetailsAction]: Missing card token');
    return [{
      ...state,
      error: CardSettingError.Generic
    }, null];
  }
  if (!hasFullCardDetails && showCardDetails) {
    const work = () => context.cardManagementService.retrieveCard(RetrieveCardRequest.create({
      cardToken: state.card?.id,
      fieldMask: {
        paths: [...DEFAULT_RETRIEVE_CARD_RESPONSE_FIELDS, 'full_pan', 'security_code', 'expiration']
      }
    })).then(response => retrieveCardReceivedAction(response, true), retrieveCardRejectedAction);
    return [{
      ...state,
      toggleLoading: {
        ...state.toggleLoading,
        showCardDetails: true
      }
    }, work];
  } else {
    return [{
      ...state,
      showCardDetails
    }, null];
  }
}
function handleUserToggleLockCard(context, state, action) {
  const {
    value
  } = action;
  const cardToken = state.card?.id;
  if (cardToken == null) {
    context.sentry.captureException("Card setting [UserToggleLockCardAction]: Missing card token");
    return [{
      ...state,
      error: CardSettingError.Generic
    }, null];
  }
  if (value) {
    const work = () => context.cardManagementService.lockCard(LockCardRequest.create({
      cardToken
    })).then(lockCardReceivedAction, lockCardRejectedAction);
    return [{
      ...state,
      toggleLoading: {
        ...state.toggleLoading,
        lockCard: true
      }
    }, work];
  }
  const work = () => context.cardManagementService.unlockCard(UnlockCardRequest.create({
    cardToken
  })).then(unlockCardReceivedAction, unlockCardRejectedAction);
  return [{
    ...state,
    toggleLoading: {
      ...state.toggleLoading,
      lockCard: true
    }
  }, work];
}
function handleUserClickOrderCard(context, state) {
  const unitToken = context.router.currentRoute.params.unit_token;
  if (!unitToken) {
    context.sentry.captureException('Card setting [UserClickOrderCardAction]: Missing unit token');
    return [{
      ...state,
      error: CardSettingError.Generic
    }, null];
  }
  const routeName = context.isFeatureEnabled('bizbank/allow_square_card_multiple_cards') ? 'banking.additional-card' : 'banking.card';
  const queryParams = {
    unitToken,
    start: true
  };

  // Add CardID to query params to represent the DigitalCardID for pairing when creating the
  // physical card
  if (state.card?.cardType === Card.CardType.CARD_TYPE_DIGITAL && state.card?.id) {
    queryParams.cardId = state.card.id;
  }
  context.router.transitionTo(routeName, {
    queryParams
  });
  return [state, null];
}
export const update = context =>
// eslint-disable-next-line complexity
(state, action) => {
  switch (action.type) {
    case ActionType.Initialize:
      return handleInitialize(state, context, action);
    case ActionType.GetCardCustomizationReceived:
      return handleGetCardCustomizationReceived(state, action);
    case ActionType.GetCardCustomizationRejected:
      return handleGetCardCustomizationRejected(context, state, action);
    case ActionType.GetCheckingDirectDepositAccount:
      return handleGetCheckingDirectDepositAccount(context, state, action);
    case ActionType.GetCheckingDirectDepositAccountReceived:
      return handleGetCheckingDirectDepositAccountReceived(context, state, action);
    case ActionType.GetCheckingDirectDepositAccountRejected:
      return handleGetCheckingDirectDepositAccountRejected(context, state, action);
    case ActionType.LockCardReceived:
      return handleLockCardReceived(context, state, action);
    case ActionType.LockCardRejected:
      return handleLockCardRejected(context, state, action);
    case ActionType.RetrieveCardReceived:
      return handleRetrieveCardReceived(context, state, action);
    case ActionType.RetrieveCardRejected:
      return handleRetrieveCardRejected(context, state, action);
    case ActionType.SetActiveSetting:
      return handleSetActiveSetting(context, state, action);
    case ActionType.UnlockCardReceived:
      return handleUnlockCardReceived(context, state, action);
    case ActionType.UnlockCardRejected:
      return handleUnlockCardRejected(context, state, action);
    case ActionType.UserClickViewReplacementCard:
      return handleUserClickViewReplacementCard(context, state);
    case ActionType.UserClickActivateCard:
      return [state, () => setActiveSettingAction(Setting.ActivateCard)];
    case ActionType.UserClickAtmLimits:
      return [state, () => setActiveSettingAction(Setting.AtmLimits)];
    case ActionType.UserClickBillingAddress:
      return [state, () => setActiveSettingAction(Setting.BillingAddress)];
    case ActionType.UserClickCancelCard:
      return [state, () => setActiveSettingAction(Setting.CancelCard)];
    case ActionType.UserClickOrderCard:
      return handleUserClickOrderCard(context, state);
    case ActionType.UserClickNotificationsPreferences:
      return [state, () => setActiveSettingAction(Setting.NotificationsPreferences)];
    case ActionType.UserClickResetPin:
      return [state, () => setActiveSettingAction(Setting.ResetPin)];
    case ActionType.UserToggleCardDetails:
      return handleUserToggleCardDetails(context, state, action);
    case ActionType.UserToggleLockCard:
      return handleUserToggleLockCard(context, state, action);
  }
};
const cardSettings = (seed, context) => {
  const w = workflow(update(context), seed);
  return {
    states: w.states,
    updates: w.updates,
    emit: w.emit
  };
};
export default cardSettings;